class PdfTemplateConfig {
    header: string;
    footer: string;
    headerHeight: number;
    footerHeight: number;

    constructor(data: any = null) {
        this.header = data?.header ?? "";
        this.footer = data?.footer ?? "";
        this.headerHeight = data?.headerHeight ?? 20;
        this.footerHeight = data?.footerHeight ?? 20;
    }
}